import { render, staticRenderFns } from "./newsfeed.vue?vue&type=template&id=12c15e06&scoped=true&"
import script from "./newsfeed.vue?vue&type=script&lang=js&"
export * from "./newsfeed.vue?vue&type=script&lang=js&"
import style0 from "./newsfeed.vue?vue&type=style&index=0&id=12c15e06&lang=scss&scoped=true&"
import style1 from "./newsfeed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c15e06",
  null
  
)

export default component.exports